'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var qwest = _interopRequireWildcard(require("qwest"));
var _moment = _interopRequireDefault(require("moment"));
var _Table = _interopRequireDefault(require("@material-ui/core/Table"));
var _TableBody = _interopRequireDefault(require("@material-ui/core/TableBody"));
var _TableCell = _interopRequireDefault(require("@material-ui/core/TableCell"));
var _TablePagination = _interopRequireDefault(require("@material-ui/core/TablePagination"));
var _TableRow = _interopRequireDefault(require("@material-ui/core/TableRow"));
var _Paper = _interopRequireDefault(require("@material-ui/core/Paper"));
var _Button = _interopRequireDefault(require("@material-ui/core/Button"));
var _Visibility = _interopRequireDefault(require("@material-ui/icons/Visibility"));
var _getErrorsFromResponse = _interopRequireDefault(require("Components/Forms/Functions/getErrorsFromResponse"));
var _TextInput = _interopRequireDefault(require("Components/Forms/Elements/TextInput"));
var _EnhancedTableHead = _interopRequireDefault(require("Components/Lists/EnhancedTableHead"));
var _Routes = require("Shared/Routes");
var _Loader = _interopRequireDefault(require("Pure/Loader"));
var _Link = _interopRequireDefault(require("Pure/Link"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
_moment.default.locale('fr');
let app = window.app;
class JobAds extends _react.Component {
  state = {
    selected: [],
    jobads: [],
    jobads_count: 0,
    page: 0,
    rows_per_page: 25,
    order: 'desc',
    order_by: 'created_at',
    companies_filter: '',
    loading: false,
    status_messages: {},
    openDeleteJobAdModal: false
  };
  componentDidMount() {
    const component = this,
      props = this.props,
      state = this.state;
    if (app.state.session?.user?.id) {
      component.setSectorInState();
    }
    app.push({
      event: 'sessionChange',
      cb: component.setSectorInState
    });
    component.fetchJobAds({});
    component.fetchCompanies();
  }
  componentWillUnmount() {
    const component = this,
      props = this.props,
      state = this.state;
    app.delete({
      event: 'sessionChange',
      cb: component.setSectorInState
    });
  }
  fetchJobAds = ({
    companies_filter,
    page,
    order,
    order_by,
    sectors_filter
  }) => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      loading: true
    });
    page = typeof page === 'undefined' ? state.page : page;
    order = order || state.order;
    order_by = order_by || state.order_by;
    const user_roles = app.state.session?.user?.roles;
    const user_id = app.state.session?.user?.id;
    qwest.post('/job-ad/get-all', {
      companies_filter: companies_filter || state.companies_filter,
      limit: state.rows_per_page,
      skip: state.rows_per_page * page,
      with_count: true,
      sectors_filter: sectors_filter || state.sectors_filter,
      user_id: user_id,
      user_roles: user_roles,
      order: order,
      order_by: order_by
    }).then(function (xhr, response) {
      component.setState({
        loading: false,
        jobads: response.jobads,
        jobads_count: response.count
      });
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...(0, _getErrorsFromResponse.default)({
          response: response
        })
      });
    });
  };
  setSectorInState = () => {
    const component = this,
      props = this.props,
      state = this.state;
    const user_sector = app.state.session?.user?.sector;
    const user_roles = app.state.session?.user?.roles;
    if (user_roles.includes('admin') || user_roles.includes('super_admin') || user_roles.includes('accompanist')) {
      component.setState({
        sectors_filter: 'all'
      });
      component.fetchJobAds({
        sectors_filter: 'all'
      });
    } else {
      component.setState({
        sectors_filter: user_sector || 'all'
      });
      component.fetchJobAds({
        sectors_filter: user_sector || 'all'
      });
    }
  };
  handleChangePage = (e, page) => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      page: page
    });
    component.fetchJobAds({
      page: page
    });
  };
  handleRequestSort = (e, column) => {
    const component = this,
      props = this.props,
      state = this.state;
    if (state.loading === true) return;
    const order_by = column.id;
    let order = 'desc';
    if (state.order_by === order_by && state.order === 'desc') {
      order = 'asc';
    }
    component.setState({
      order: order,
      order_by: order_by,
      loading: true
    });
    component.fetchJobAds({
      order: order,
      order_by: order_by
    });
  };
  handleSearchChange = ({
    e,
    value,
    name
  }) => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      companies_filter: value
    });
    if (component.timeout) window.clearTimeout(component.timeout);
    component.timeout = window.setTimeout(function () {
      component.timeout = undefined;
      component.fetchJobAds({
        companies_filter: value
      });
    }, 800);
  };
  fetchCompanies = () => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      loading: true
    });
    qwest.post('/company/get-all').then(function (xhr, response) {
      component.setState({
        loading: false,
        companies: response.companies
      });
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...(0, _getErrorsFromResponse.default)({
          response: response
        })
      });
    });
  };
  getCompanyName = company_id => {
    const component = this,
      props = this.props,
      state = this.state;
    if (!state.companies) return;
    const company = (state.companies || []).find(company => company.id === company_id);
    return company?.company_name;
  };
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    _moment.default.locale('fr');
    const loader = state.loading === true ? /*#__PURE__*/_react.default.createElement(_Loader.default, {
      className: "c-loader",
      bemit: ['white', 'bg-carbon']
    }) : undefined;
    const empty_rows = state.rows_per_page - Math.min(state.rows, state.jobads_count - state.page * state.rows_per_page);
    const columns = [{
      id: 'company_name',
      sortable: false,
      numeric: false,
      label: 'Entreprise',
      center: true
    }, {
      id: 'title',
      sortable: false,
      numeric: false,
      label: 'Titre de l\'annonce',
      center: true
    }, {
      id: 'contract_type',
      sortable: false,
      numeric: false,
      label: 'Type de contrat',
      center: true
    }, {
      id: 'salary',
      sortable: false,
      numeric: false,
      label: 'Salaire',
      center: true
    }, {
      id: 'start_date',
      sortable: false,
      numeric: false,
      label: 'Date de début',
      center: true
    }, {
      id: 'updated_at',
      sortable: false,
      numeric: false,
      label: 'Dernière mise à jour',
      center: true
    }, {
      id: 'updated_at',
      sortable: false,
      numeric: false,
      label: 'Statut',
      center: true
    }, {
      id: 'interested_candidates',
      sortable: false,
      numeric: false,
      label: 'Candidat(s) intéressé(s)',
      center: true
    }, {
      id: 'actions',
      sortable: false,
      numeric: false,
      label: 'Visualiser l\'annonce',
      center: true
    }];
    const job_ads = (state.jobads || []).map(function (data) {
      const link = /*#__PURE__*/_react.default.createElement(_Link.default, {
        href: '/liste-des-annonces/' + data.id,
        className: "u-link-only"
      });
      let output = /*#__PURE__*/_react.default.createElement(_TableRow.default, {
        hover: true,
        tabIndex: -1,
        key: data.id
      }, /*#__PURE__*/_react.default.createElement(_TableCell.default, {
        className: "table-cell",
        align: "center"
      }, component.getCompanyName(data.company_id), link), /*#__PURE__*/_react.default.createElement(_TableCell.default, {
        className: "table-cell",
        align: "center"
      }, data.title, link), /*#__PURE__*/_react.default.createElement(_TableCell.default, {
        className: "table-cell",
        align: "center"
      }, data.contract_type, link), /*#__PURE__*/_react.default.createElement(_TableCell.default, {
        className: "table-cell",
        align: "center"
      }, data.salary, link), /*#__PURE__*/_react.default.createElement(_TableCell.default, {
        className: "table-cell",
        align: "center"
      }, (0, _moment.default)(data.start_date).format('DD/MM/YYYY'), link), /*#__PURE__*/_react.default.createElement(_TableCell.default, {
        className: "table-cell",
        align: "center"
      }, (0, _moment.default)(data.updated_at).format('DD/MM/YYYY HH:mm'), link), /*#__PURE__*/_react.default.createElement(_TableCell.default, {
        className: "table-cell",
        align: "center"
      }, data.status), /*#__PURE__*/_react.default.createElement(_TableCell.default, {
        className: "table-cell",
        align: "center"
      }, data.interested_candidates.length || 0, link), /*#__PURE__*/_react.default.createElement(_TableCell.default, {
        className: "table-cell",
        align: "center"
      }, data.status === "Ouverte" ? /*#__PURE__*/_react.default.createElement(_Button.default, {
        href: "/annonces/" + data.id,
        color: "primary",
        variant: "contained",
        target: "_blank",
        className: "u-padding-10 u-margin-right-10 u-text-center",
        component: props => /*#__PURE__*/_react.default.createElement(_Link.default, props)
      }, /*#__PURE__*/_react.default.createElement(_Visibility.default, null)) : undefined));
      return output;
    });
    const user_roles = app.state.session?.user?.roles;
    let output = /*#__PURE__*/_react.default.createElement(_Paper.default, {
      className: "dashboard-table",
      elevation: 2
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "dashboard-filter"
    }, /*#__PURE__*/_react.default.createElement(_TextInput.default, {
      onChange: component.handleSearchChange,
      className: "u-padding-left-10 u-padding-right-10 u-full-width",
      name: "companies_filter",
      label: "Recherche par entreprise",
      status: state.status_messages,
      value: state.companies_filter
    }), !user_roles.includes('accompanist') ? /*#__PURE__*/_react.default.createElement(_Button.default, {
      href: (0, _Routes.URL)('NewJobAdBack', _Routes.front_urls),
      color: "primary",
      variant: "contained",
      className: "u-padding-10 u-margin-right-10 u-text-center\r u-nowrap",
      style: {
        whiteSpace: 'nowrap',
        flexShrink: 0
      }
    }, "Cr\xE9er une annonce") : undefined), /*#__PURE__*/_react.default.createElement(_Table.default, {
      "aria-labelledby": "Annonces"
    }, /*#__PURE__*/_react.default.createElement(_EnhancedTableHead.default, {
      onRequestSort: component.handleRequestSort,
      order: state.order,
      order_by: state.order_by,
      row_count: job_ads.length,
      columns: columns
    }), /*#__PURE__*/_react.default.createElement(_TableBody.default, null, job_ads, empty_rows > 0 ? /*#__PURE__*/_react.default.createElement(_TableRow.default, {
      style: {
        height: 49 * empty_rows
      }
    }, /*#__PURE__*/_react.default.createElement(_TableCell.default, {
      colSpan: 4
    })) : undefined)), /*#__PURE__*/_react.default.createElement(_TablePagination.default, {
      onChangePage: component.handleChangePage,
      component: "div",
      count: state.jobads_count,
      rowsPerPage: state.rows_per_page,
      rowsPerPageOptions: [],
      page: state.page,
      backIconButtonProps: {
        'aria-label': 'Page précédente'
      },
      nextIconButtonProps: {
        'aria-label': 'Page suivante'
      },
      labelDisplayedRows: ({
        from,
        to,
        count
      }) => from + '-' + to + ' sur ' + count
    }), loader);
    return output;
  }
}
exports.default = JobAds;
